import { CommonResponse } from '@gtpl/shared-models/masters';
import { AllFgInspectionsResponse, FgInspectionResponse } from '@gtpl/shared-models/production-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { FgInspectionDTO } from './dto/fg-inspection.dto';
import { FgInspectionService } from './fg-inspection.service';
import { FgInspectionRequest } from './dto/fg-inspection.request';

@ApiTags('fg-inspection')
@Controller('fg-inspection')
export class FgInspectionController {

    constructor(
        private service: FgInspectionService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createFgInspection')
    async createFgInspection(@Body() inspecInfo: FgInspectionDTO): Promise<FgInspectionResponse>{
        try{ 
            return await this.service.createFgInspection(inspecInfo,false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(FgInspectionResponse, error);
        }
    }
    @Post('/updateFgInspectionInfo')
    async updateFgInspectionInfo(@Body() inspecInfo: FgInspectionDTO): Promise<FgInspectionResponse>{
        try{ 
            return await this.service.createFgInspection(inspecInfo,true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(FgInspectionResponse, error);
        }
    }

    @Post('/getAllFgInspections')
    async getAllFgInspections(): Promise<AllFgInspectionsResponse>{
        try{ 
            return await this.service.getAllFgInspections();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllFgInspectionsResponse, error);
        }
    }

    @Post('/getAllActiveFgInspections')
    async getAllActiveFgInspectionsInfo(): Promise<AllFgInspectionsResponse>{
        try{ 
            return await this.service.getAllActiveFgInspections();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllFgInspectionsResponse, error);
        }
    }

    @Post('/activateOrDeactivateFgInspection')
    async activateOrDeactivateFgInspection(@Body() req: FgInspectionRequest): Promise<FgInspectionResponse>{
        try{ 
            return await this.service.activateOrDeactivateFgInspection(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(FgInspectionResponse, error);
        }
    }

    @Post('/createFgInspectionInfo')
    async createFgInspectionInfo(@Body() inspecInfo: FgInspectionDTO):Promise<CommonResponse>{
        try{
            return await this.service.createFgInspectionInfo(inspecInfo);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getAllFgInspectionSamplesForLabelId')
    async getAllFgInspectionSamplesForLabelId(@Body() qReq: FgInspectionRequest): Promise<FgInspectionResponse> {
        try {
            return await this.service.getAllFgInspectionSamplesForLabelId(qReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FgInspectionResponse, error);
        }
    }
}
